// 法务页面：隐私政策与服务协议。
// 内容按本产品的真实实现写（阿里云 OSS/百炼、火山 TOS/方舟、成都单机部署、
// 90 天日志、2FA/TOTP 字段加密、租户隔离、RBAC 四角色），不写我们没做到的承诺。
// 【草案 v0.1 — 上线前必须请法务审阅；联系邮箱与生效日期见文件末尾 TODO】
import { Link } from 'react-router-dom'

const COMPANY = '成都正切科技有限公司'
const SITE = 'tangentmark.com'

const PRIVACY = [
  { h: '一、我们是谁', p: [
    `本政策由 ${COMPANY}（${SITE} 网站备案号：蜀ICP备2026035347号-1，以下简称"我们"）制定，适用于"全景 OmniTuring"品牌数字资产与记忆库服务及"全迹 OmniTrace"品牌 AI 可见度服务（合称"本服务"）。`,
    '本服务为企业与品牌团队提供的管理工具，不面向不特定公众提供内容发布，也不以个人用户为服务对象。',
  ] },
  { h: '二、我们收集哪些信息', p: [
    '账号信息：注册邮箱或手机号、密码加盐哈希（不保存明文）、可选的微信 OpenID、两步验证（TOTP）密钥与备用恢复码（密钥经字段级加密后存储）。',
    '组织信息：您在引导流程中填写的企业名称、行业、规模、账号类型（个人/企业）以及团队成员的角色（企业主/管理员/编辑者/成员）。',
    '业务数据：您主动上传的品牌数字资产（文档、图片、音视频等原始文件）及由系统从中提取的文本、图像描述、转写结果、标签、知识事实与图谱关系（合称"客户内容"）。',
    '使用与安全日志：检索请求、AI 模型调用与用量成本、资产访问计数、登录与登出事件、权限变更、安全事件（含失败尝试）、请求编号与来源 IP。',
    '我们不收集您的客户身份档案、不嵌入第三方广告或跟踪代码，也不通过本服务向第三方投放追踪。',
  ] },
  { h: '三、我们为什么需要这些信息', p: [
    '提供核心功能：资产存储与检索（关键词 + 语义向量 + 精排）、品牌知识沉淀与图谱、AI 元数据提取、品牌合规检查、分享与协作、配额与用量核算。',
    '保障安全：身份认证、会话吊销与登出、越权与异常行为审计、上传文件的安全扫描（魔术字节、扩展名白名单、可执行文件检测）。',
    '履行合同与法定义务：计费与对账、日志留存、应监管要求配合提供必要记录。',
    '我们不会将客户内容用于向其他客户展示、公开传播或任何形式的对外出售。',
  ] },
  { h: '四、委托处理与数据存储位置', p: [
    '服务器与数据库位于中国境内；对象存储使用阿里云 OSS 与火山引擎 TOS，AI 能力使用阿里云百炼（DashScope）与火山引擎方舟（Ark）大模型服务。',
    '为完成检索与分析，本服务会把必要的文本或图像发送给上述模型服务商用于推理。各服务商对输入数据的使用与保留以其公开协议为准；我们不会把客户内容用于模型训练目的之外的自行使用。',
    '我们会与上述受托方签署保密与数据处理约定，并仅传输实现功能所必需的最小范围数据。',
    '未经您的同意，除法律法规要求或为保护本服务安全所必需外，我们不向任何第三方提供您的客户内容。',
  ] },
  { h: '五、存储期限', p: [
    '账号信息与业务数据在服务存续期间保留；您删除资产或注销账号后，相关记录按第六、八条处理。',
    '使用与安全日志默认保留 90 天后自动清理。',
    '备份：数据库与资产归档按滚动策略保留（本地 7 天，另有一份云端归档），用于故障恢复；恢复演练会临时使用备份数据，不对外暴露。',
  ] },
  { h: '六、您对您的信息享有的权利', p: [
    '查阅与更正：在"账号设置 / 团队"页面直接查看与修改。',
    '导出：通过"安全设置"中的数据导出功能获取您的账号与内容记录副本。',
    '删除：删除单个资产或全部数据；已封存的资产按合规留痕要求仅归档隐藏、不物理删除，我们会在界面中明确标示这一状态。',
    '撤回同意与注销：可随时关闭两步验证、退出团队或申请注销账号；注销后我们将停止处理并删除或匿名化相关数据，法定留存义务所要求的除外。',
    '行使方式见第八条联系方式；我们将在 15 个工作日内响应。',
  ] },
  { h: '七、我们如何保护数据', p: [
    '传输加密：全站 HTTPS（TLS，证书由 Let’s Encrypt 签发并自动续期）。',
    '访问控制：多租户数据隔离（查询强制携带租户范围）、四种角色的权限体系、敏感管理操作二次校验、平台管理员与普通租户权限分离。',
    '凭证安全：JWT 会话支持吊销与登出黑名单、两步验证、密钥字段级加密；访问凭据不通过 URL 传递，媒体直链使用与单个资产绑定、短期有效的一次性令牌。',
    '运维：操作日志与审计事件留痕、数据库定期备份并做恢复验证。',
    '互联网环境不存在绝对安全。若发生可能损害您权益的数据安全事件，我们将依法及时告知您事件情况、可能影响、已采取的措施与防范建议。',
  ] },
  { h: '八、联系方式与政策更新', p: [
    '我们会在本页面更新本政策；对本条第 2 款所列重大变更，我们将通过站内提示或您预留的邮箱提前告知。',
    '隐私相关问题、权利请求与投诉，请联系：【TODO 待填：隐私负责人邮箱】；或寄至 ${COMPANY} 工商登记地址并注明"隐私事务"。',
  ] },
]

const TERMS = [
  { h: '一、协议的接受与主体', p: [
    `本协议是您与 ${COMPANY} 之间就使用"全景 OmniTuring / 全迹 OmniTrace"服务（${SITE}）订立的合同。注册、登录或使用本服务即表示您已阅读并同意本协议。`,
    '您代表您所隶属的企业或团队使用本服务时，请确认您已获得相应授权。',
  ] },
  { h: '二、服务内容', p: [
    '本服务提供品牌数字资产的存储、检索、整理、AI 元数据提取、品牌知识沉淀（事实与图谱）、品牌合规检查、分享与团队协作、用量与配额管理等功能。',
    '我们可能根据产品与合规需要调整、增加或限制功能；对影响核心使用的重大调整，会提前在站内或邮件告知。',
  ] },
  { h: '三、账号与安全责任', p: [
    '您应妥善保管账号、密码与两步验证设备，并对账号下发生的全部操作负责。发现账号被冒用应立即通知我们并修改凭据。',
    '团队版中，企业主/管理员对成员与权限配置负责；成员的操作在其权限范围内对贵方生效。',
    '您不得将账号出借、转让或出售给第三方。',
  ] },
  { h: '四、客户内容的权利归属', p: [
    '您上传的品牌素材及由此产生的元数据、知识事实等（"客户内容"）的权利归您或您的合法权利人所有。',
    '您授予我们为履行本服务所必需的处理许可：存储、复制、转换格式、生成缩略图与向量、调用模型进行分析、以及在您指定的分享范围内向被分享者展示。该许可在服务终止或您删除内容后按第五条终止。',
    '您应确保对您上传的内容拥有合法权利，不侵犯第三方知识产权、商业秘密、肖像权、个人信息权益等合法权益。',
  ] },
  { h: '五、禁止行为', p: [
    '上传含有法律法规禁止内容、恶意代码或用于攻击他人的文件。',
    '绕过或破坏访问控制、配额与速率限制、租户隔离、鉴权或审计机制；对服务进行未授权的扫描、探测、压测或逆向。',
    '利用本服务存储或分发侵权、虚假或误导性品牌宣称，或规避广告法等合规审查。',
    '以自动化方式大量抓取本服务数据或干扰其正常运行。',
    '我们有权在通知的前提下对违规行为采取限制功能、暂停服务或终止账号等措施，并保留追责权利。',
  ] },
  { h: '六、AI 生成结果的性质与使用限制', p: [
    '本服务中的标题、描述、标签、知识事实、合规提示与报告等由模型自动生成，属于辅助性建议，可能存在错误、遗漏或偏差。',
    '系统会为结果标注来源与信任等级，并提供人工审阅入口；您应在对外发布、商业决策或合规判断前自行复核。',
    'AI 生成内容不构成法律、财务、医疗或其他专业意见。您基于本服务输出所作的商业决策与对外宣称，由您自行负责，包括其真实与合规性。',
  ] },
  { h: '七、费用与套餐', p: [
    '本服务按套餐（免费版/个人专业版/团队版等）提供，套餐决定存储、资产数量、成员席位与功能范围等限额。',
    '当前付费方式为线下签约与对公转账，我们尚未开通在线支付；具体价格、期限与续期方式以双方签署的合同或订单为准。',
    '试用期结束或费用到期后，我们可能将账号调整为免费额度或限制写入，并保留您的数据以便续费后恢复；我们会在界面中明确标示当前状态。',
    '已支付费用原则上不退；法律法规另有规定或合同另有约定的除外。',
  ] },
  { h: '八、服务可用性与维护', p: [
    '我们努力保障服务连续可用，但本服务当前为单节点部署，不提供未经书面约定的可用性等级（SLA）承诺。',
    '因系统维护、升级、第三方云或模型服务商故障、不可抗力导致的服务中断或延迟，我们在法律允许的范围内不承担赔偿责任，但会尽力减少影响并及时告知。',
    '您应自行对重要数据保留副本；我们提供的备份与恢复机制不免除您的备份义务。',
  ] },
  { h: '九、协议终止与数据处理', p: [
    '您可随时停止使用并申请注销账号；我们可在您严重违约时终止服务。',
    '终止后，我们会在合理期限内为您提供数据导出途径；期限届满后，我们将删除或匿名化客户内容，法定留存义务与合规封存要求所必需的数据除外（此类数据将继续按第四条许可范围受限保存）。',
  ] },
  { h: '十、责任限制', p: [
    '在法律允许的最大范围内，我们对因使用或无法使用本服务造成的间接损失、利润或商誉损失不承担责任。',
    '对有偿服务，我们的累计赔偿责任以您在事件发生前十二个月内就本服务实际支付的费用为限；对免费服务，以法律允许的下限为限。',
    '本条不免除我们对故意或重大过失、以及依法不得免除的责任。',
  ] },
  { h: '十一、法律适用与争议解决', p: [
    '本协议适用中华人民共和国法律。因本协议产生的争议，双方应友好协商；协商不成的，提交 ${COMPANY} 住所地有管辖权的人民法院诉讼解决。',
    '本协议未尽事宜，参照我们公布的其他规则、套餐说明与双方合同执行；不一致时以双方签署的合同为准。',
  ] },
]

function render(doc) {
  return doc.map((sec) => (
    <section key={sec.h} className="mb-8">
      <h2 className="text-[15px] font-semibold mb-3" style={{ color: '#1C1917' }}>{sec.h}</h2>
      <ul className="space-y-2.5">
        {sec.p.map((t, i) => (
          <li key={i} className="text-[13.5px] leading-[1.85]" style={{ color: '#57534E' }}>
            {t.replace(/\$\{COMPANY\}/g, COMPANY)}
          </li>
        ))}
      </ul>
    </section>
  ))
}

export default function LegalPage({ kind = 'privacy' }) {
  const isPrivacy = kind !== 'terms'
  const doc = isPrivacy ? PRIVACY : TERMS
  return (
    <div className="min-h-screen" style={{ background: '#FBF9F5' }}>
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="text-[13px]" style={{ color: '#C1751B' }}>← 返回全景 OmniTuring</Link>
        <h1 className="text-2xl font-bold mt-4 mb-2" style={{ color: '#1C1917' }}>
          {isPrivacy ? '隐私政策' : '全景 OmniTuring 服务协议'}
        </h1>
        <p className="text-[12.5px] mb-8" style={{ color: '#A8A29E' }}>
          {COMPANY} ｜ 网站：{SITE} ｜ 备案号：蜀ICP备2026035347号-1
          <br />版本：草案 v0.1 ｜ 生效日期：【TODO 待填】 ｜ 本文发布前须经法务审阅
        </p>
        {render(doc)}
        <div className="mt-10 pt-6 text-[12px] leading-relaxed" style={{ color: '#A8A29E', borderTop: '1px solid #E7E5E4' }}>
          本文件为草案，不构成正式法律意见。上线前请由法务确认联系方式、生效日期、
          责任限额与管辖条款，并核对与云服务商及模型服务商协议的一致性。
        </div>
      </div>
    </div>
  )
}
